import api from './api';

export const getBlogPosts = async (page = 1, limit = 10, tag = null) => {
  let url = `/blog?page=${page}&limit=${limit}`;
  if (tag) {
    url += `&tag=${encodeURIComponent(tag)}`;
  }
  const response = await api.get(url);
  return response.data;
};

export const getBlogPostBySlug = async (slug) => {
  const response = await api.get(`/blog/${slug}`);
  return response.data;
};

export const getBlogPostById = async (id) => {
  const response = await api.get(`/blog/id/${id}`);
  return response.data;
};

export const createBlogPost = async (postData) => {
  const response = await api.post('/blog', postData);
  return response.data;
};

export const updateBlogPost = async (id, postData) => {
  const response = await api.put(`/blog/${id}`, postData);
  return response.data;
};

export const deleteBlogPost = async (id) => {
  const response = await api.delete(`/blog/${id}`);
  return response.data;
};

export const addComment = async (postId, text) => {
  const response = await api.post(`/blog/${postId}/comments`, { text });
  return response.data;
};

// New file upload functions
export const uploadFiles = async (files) => {
  const formData = new FormData();
  
  // Add all files to the formData
  for (let i = 0; i < files.length; i++) {
    formData.append('files', files[i]);
  }
  
  // Use custom headers for multipart/form-data
  const response = await api.post('/blog/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  
  return response.data;
};

export const deleteFile = async (postId, fileIndex) => {
  const response = await api.delete(`/blog/file/${postId}/${fileIndex}`);
  return response.data;
}; 